module.exports = __webpack_public_path__ + "img/swiper_05.b44ae889.jpg";